// Global Instructions Rule Applied! - 2026-05-08
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import type { UserPreferenceReportModel } from '../data_models/user_preference_report_model.ts'
import { resolveTableColumnKeysFromPreferenceRow } from '../../app_modules/global_configs/tableViewPreferences.ts'
import { getReportingGridColumnsWithUserColumnKeys } from '../utils/reportingGridColumns.ts'

/**
 * Reporting grid columns for a report, ordered by per-report `cfg.reporting_columns`
 * (display_order, NULLs last) with per-usage overrides layered on `cfg.reporting_column_defaults`,
 * unless `preferenceRow.data.table_column_keys` overrides.
 */
export function useReportingGridColumnsWithPreferences(
  reportId: string | null | undefined,
  preferenceRow: UserPreferenceReportModel | undefined
) {
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])
  const reportingColumnDefaults = useSelector(
    (state: RootState) => state.globalConfigs?.reporting_column_defaults ?? []
  )
  const reportingColumns = useSelector((state: RootState) => state.globalConfigs?.reporting_columns ?? [])
  const reportingModules = useSelector((state: RootState) => state.globalConfigs?.reporting_modules ?? [])

  return useMemo(
    () =>
      getReportingGridColumnsWithUserColumnKeys(
        reportId ?? undefined,
        {
          reporting_configs: reportingConfigs,
          reporting_column_defaults: reportingColumnDefaults,
          reporting_columns: reportingColumns,
          reporting_modules: reportingModules
        },
        resolveTableColumnKeysFromPreferenceRow(preferenceRow)
      ),
    [
      reportId,
      preferenceRow,
      reportingConfigs,
      reportingColumnDefaults,
      reportingColumns,
      reportingModules
    ]
  )
}
